/**
 * shadcn/ui Label (Radix) on the brand tokens. Author: Mahmoud Ragab Ahmed.
 */
import { Label as LabelPrimitive } from "radix-ui";

import { cn } from "@/lib/utils";

export function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>): React.JSX.Element {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm tracking-[0.04em] text-muted-foreground select-none",
        className,
      )}
      {...props}
    />
  );
}
